import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class StaffCounts extends DomainObject {
  active;
  onLeave;
  fullTime;
  partTime;
  temp;
  intern;
  volunteer;
  contractor;
  seasonal;
  casual;

  constructor(other) {
    super();

    makeObservable(this, {
      active: observable,
      onLeave: observable,
      fullTime: observable,
      partTime: observable,
      temp: observable,
      intern: observable,
      volunteer: observable,
      contractor: observable,
      seasonal: observable,
      casual: observable
    });

    this.merge(other);
  }
}

export default StaffCounts;
